import { render, staticRenderFns } from "./MusicAdd.vue?vue&type=template&id=2c758703&scoped=true"
import script from "./MusicAdd.vue?vue&type=script&lang=js"
export * from "./MusicAdd.vue?vue&type=script&lang=js"
import style0 from "./MusicAdd.vue?vue&type=style&index=0&id=2c758703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c758703",
  null
  
)

export default component.exports